import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { getTeeColor } from './teeColor';

const StepTees = ({ tees, updateTee, addTee, removeTee }) => (
  <div className="cw-section">
    <p className="cw-section-hint">
      Add each set of tees with its course &amp; slope rating. You'll set pars and stroke indexes in the next step.
    </p>

    <div className="cw-tee-list">
      {tees.map((tee) => {
        const missingName = tee.name.trim().length === 0;
        return (
          <div key={tee._key} className="cw-tee-row">
            <span className="cw-tee-dot" style={{ background: getTeeColor(tee.name) }} />

            <div className="cw-tee-fields">
              <div className="cw-field cw-field--grow">
                <label>Tee name</label>
                <input
                  type="text"
                  className={missingName ? 'cw-input--warn' : ''}
                  placeholder="White, Yellow, Red…"
                  value={tee.name}
                  onChange={e => updateTee(tee._key, 'name', e.target.value)}
                />
              </div>
              <div className="cw-field cw-field--num">
                <label>Course rating</label>
                <input
                  type="number" inputMode="decimal" step="0.1"
                  placeholder="72.0"
                  value={tee.course_rating}
                  onChange={e => updateTee(tee._key, 'course_rating', e.target.value)}
                />
              </div>
              <div className="cw-field cw-field--num">
                <label>Slope</label>
                <input
                  type="number" inputMode="numeric"
                  placeholder="113"
                  value={tee.slope_rating}
                  onChange={e => updateTee(tee._key, 'slope_rating', e.target.value)}
                />
              </div>
            </div>

            {tees.length > 1 && (
              <button
                className="cw-tee-delete"
                onClick={() => removeTee(tee._key)}
                aria-label={`Delete ${tee.name || 'tee'}`}
              >
                <FiTrash2 size={16} />
              </button>
            )}
          </div>
        );
      })}
    </div>

    <button className="cw-add-tee" onClick={addTee}>
      <FiPlus size={16} /> Add tee
    </button>
  </div>
);

export default StepTees;
